export enum BiometricReaderType {
  DigitalPersona = 0,
  Futronic = 1,
}

export interface BiometricReader {
  InstanceId: string;
  Name: string;
  Type: BiometricReaderType;
}

export enum FingerPosition {
  LeftThumb = 0,
  LeftIndex = 1,
  LeftMiddle = 2,
  LeftRing = 3,
  LeftPinky = 4,
  RightThumb = 5,
  RightIndex = 6,
  RightMiddle = 7,
  RightRing = 8,
  RightPinky = 9,
}

export type TemplateRaw = string;

export interface EnrolledTemplate {
  templateId: string;
  finger: FingerPosition;
}

export interface IProfileBiometricsStore {
  personId: string | null;
  readers: BiometricReader[];
  selectedReader: BiometricReader | null;
  lastCapture: TemplateRaw | null;
  lastCaptureIsValid: boolean | null;
  lastCompareMatched: boolean | null;
  pendingTemplates: TemplateRaw[];
  enrolledTemplates: EnrolledTemplate[];
}

export const initialProfileBiometricsStore: IProfileBiometricsStore = {
  personId: null,
  readers: [],
  selectedReader: null,
  lastCapture: null,
  lastCaptureIsValid: null,
  lastCompareMatched: null,
  pendingTemplates: [],
  enrolledTemplates: [],
};
